'use strict';

import ready from '../parent/js/lib/ready';
import promiseIdle from '../parent/js/lib/promise-idle';
import ToggleArea from '../parent/js/lib/ToggleArea';
import ButtonBehavior from '../parent/js/lib/ToggleArea_ButtonBehavior';

ready().then(promiseIdle()).then(function () {

    const observer = new MutationObserver(mutations => {
        mutations.forEach(mutation => update(mutation.target.querySelector(':scope > button')));
    });

    function update(toggle) {
        Promise.resolve(toggle._area).then(area => {
            if (toggle.closest('.nav__inner')) {
                toggle._area = area ? area.destroy() : null;
            } else {
                toggle._area = area || (new ToggleArea(toggle.nextElementSibling, 'submenu', [
                    new ButtonBehavior(toggle, {
                        jail: false,
                        closeOnBlur: true,
                    })
                ])).ready();
            }
        });
    }

    const toggles = document.querySelectorAll('.menu-lang__toggle');

    toggles.forEach(update);

    toggles.forEach(toggle => {
        observer.observe(toggle.parentNode, {attributes: true});
    });
});
